import { BuildBootstrapFunctionReturn, bootstrap as messagingBootstrap } from "@lookiero/messaging-react";
import { VIEW_IS_LOOK_IN_ENABLED, viewIsLookInEnabledHandler } from "../../projection/lookIn/viewIsLookInEnabled";
import {
  IsCategoriesOfferingEnabledView,
  viewIsCategoriesOfferingEnabledHandler,
  VIEW_IS_CATEGORIES_OFFFERING_ENABLED,
} from "../../projection/offering/viewIsCategoriesOfferingEnabled";
import {
  IsCompleteYourLookOfferingEnabledView,
  viewIsCompleteYourLookOfferingEnabledHandler,
  VIEW_IS_COMPLETE_YOUR_LOOK_OFFFERING_ENABLED,
} from "../../projection/offering/viewIsCompleteYourLookOfferingEnabled";
import {
  IsSalesOfferingEnabledView,
  viewIsSalesOfferingEnabledHandler,
  VIEW_IS_SALES_OFFFERING_ENABLED,
} from "../../projection/offering/viewIsSalesOfferingEnabled";
import {
  IsTrendingForYouOfferingEnabledView,
  viewIsTrendingForYouOfferingEnabledHandler,
  VIEW_IS_TRENDING_FOR_YOU_OFFFERING_ENABLED,
} from "../../projection/offering/viewIsTrendingForYouOfferingEnabled";

const MESSAGING_CONTEXT_ID = "LookIn";

interface BaseBootstrapFunctionArgs {
  readonly isCompleteYourLookOfferingEnabledView: IsCompleteYourLookOfferingEnabledView;
  readonly isCategoriesOfferingEnabledView: IsCategoriesOfferingEnabledView;
  readonly isSalesOfferingEnabledView: IsSalesOfferingEnabledView;
  readonly isTrendingForYouOfferingEnabledView: IsTrendingForYouOfferingEnabledView;
}

interface BaseBootstrapFunction {
  (args: BaseBootstrapFunctionArgs): BuildBootstrapFunctionReturn;
}

const baseBootstrap: BaseBootstrapFunction = ({
  isCompleteYourLookOfferingEnabledView,
  isCategoriesOfferingEnabledView,
  isSalesOfferingEnabledView,
  isTrendingForYouOfferingEnabledView,
}) => {
  const messaging = messagingBootstrap({ id: MESSAGING_CONTEXT_ID })
    .query(VIEW_IS_LOOK_IN_ENABLED, viewIsLookInEnabledHandler)
    .query(VIEW_IS_COMPLETE_YOUR_LOOK_OFFFERING_ENABLED, viewIsCompleteYourLookOfferingEnabledHandler, {
      view: isCompleteYourLookOfferingEnabledView,
    })
    .query(VIEW_IS_CATEGORIES_OFFFERING_ENABLED, viewIsCategoriesOfferingEnabledHandler, {
      view: isCategoriesOfferingEnabledView,
    })
    .query(VIEW_IS_SALES_OFFFERING_ENABLED, viewIsSalesOfferingEnabledHandler, {
      view: isSalesOfferingEnabledView,
    })
    .query(VIEW_IS_TRENDING_FOR_YOU_OFFFERING_ENABLED, viewIsTrendingForYouOfferingEnabledHandler, {
      view: isTrendingForYouOfferingEnabledView,
    });

  return messaging.build();
};

export { MESSAGING_CONTEXT_ID, baseBootstrap };
